"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusBar = void 0;
const React = require("react");
const react_native_1 = require("react-native");
const react_native_status_bar_height_1 = require("react-native-status-bar-height");
const theme_1 = require("../modules/theme");
class StatusBar extends React.Component {
    constructor() {
        super(...arguments);
        this.getStyles = () => {
            const theme = (0, theme_1.getTheme)();
            const { extraHeight } = this.props;
            const styles = react_native_1.StyleSheet.create({
                statusBar: {
                    backgroundColor: theme.statusBarColor,
                    height: (0, react_native_status_bar_height_1.getStatusBarHeight)() + extraHeight
                }
            });
            return styles;
        };
    }
    render() {
        const styles = this.getStyles();
        return (React.createElement(react_native_1.View, { style: styles.statusBar },
            React.createElement(react_native_1.StatusBar, { backgroundColor: "transparent", barStyle: "light-content", translucent: true })));
    }
}
exports.StatusBar = StatusBar;
StatusBar.height = (0, react_native_status_bar_height_1.getStatusBarHeight)();
StatusBar.defaultProps = {
    extraHeight: 0
};
